





















































































































































































































































import cloneDeep from "lodash/cloneDeep";

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";

import TitleBar from "@/components/Elements/TitleBar.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      "loading",
      "loaded",
      "fatalError",

      "filter",

      "documents",
      "lastMeta"
    ])
  },
  methods: {
    ...mapActions(STORE_KEY, ["exportData"])
  },
  components: {
    TitleBar
  }
})
export default class EmployeeList extends Vue {
  radioButton = 1;
  open = false;

  get titleStack() {
    return ["Контрагенты"];
  }

  getQueryParam(field: string) {
    return this.$route.query ? cloneDeep(this.$route.query[field]) : null;
  }

  // ---------------------------------------------------------------------------

  get clientTypes() {
    return [
      {
        id: "client",
        label: "Клиент"
      },
      {
        id: "partner",
        label: "Партнер"
      },
      {
        id: "supplier",
        label: "Поставщик"
      }
    ];
  }

  filterForm: any = {};

  get filtersCount() {
    return Object.keys(this.filterForm).reduce(
      (cur: number, filterKey: any) => {
        return (
          cur +
          (this.filterForm[filterKey] && this.filterForm[filterKey].length > 0
            ? 1
            : 0)
        );
      },
      0
    );
  }

  @Watch("$route.query")
  public checkFilterChange() {
    this.filterForm = {
      cities: this.getQueryParam("cities"),
      paymentTypes: this.getQueryParam("paymentTypes"),
      managers: this.getQueryParam("managers"),
      clientTypes: this.getQueryParam("clientTypes"),
      deliveryZoneGroups: this.getQueryParam("deliveryZoneGroups")
    };
  }

  applyFilter() {
    this.$router.replace({
      query: {
        ...this.$route.query,
        ...this.filterForm
      }
    });

    (this.$refs.filter as any).close();
  }

  clearFilter() {
    this.filterForm = {
      cities: null,
      paymentTypes: null,
      managers: null,
      clientTypes: null,
      deliveryZoneGroups: null
    };

    (this.$refs.filter as any).close();
  }

  // ---------------------------------------------------------------------------

  get defaultSort() {
    return [
      this.$route.query.sortField || "name",
      this.$route.query.sortDirection || "asc"
    ];
  }

  get selectedView() {
    return this.$route.query.view || "linked";
  }

  onSort(field: string, direction: string) {
    console.log("onSort", field, direction);
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortField: field,
        sortDirection: direction
      }
    });
  }
  private delayFilter: any = null;

  onSearch(filter: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...filter
          }
        });
        this.delayFilter = null;
      }, 3000);
    }
    this.delayFilter = filter;
  }

  onPageChange(page: string) {
    console.log("onPageChange", page);
    this.$router.replace({
      query: { ...this.$route.query, page }
    });
  }

  // ---------------------------------------------------------------------------

  openDocument(row: any) {
    this.$router.push({
      name: "client-details",
      params: {
        id: row.id
      }
    });
  }

  // ---------------------------------------------------------------------------

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.checkFilterChange();
    this.handleParamsChange();
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

  public beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch("$route.query")
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }
}
